import Vue from 'vue'
import Router from 'vue-router'


import Shouye from '@/components/main/shouye'
import Login from '@/components/main/login'
import List from '@/components/main/list'
import Listm from '@/components/main/listm'
import Baohu from '@/components/main/baohu'
import Changjing from '@/components/main/changjing'
import Changjing1 from '@/components/main/changjing1'
import Changjing2 from '@/components/main/changjing2'
import Changjing3 from '@/components/main/changjing3'

import Dianpu1 from '@/components/main/dianpu1'
import Dianpu2 from '@/components/main/dianpu2'
import Dianpu3 from '@/components/main/dianpu3'
import Dianpu4 from '@/components/main/dianpu4'

import Jianjie from '@/components/main/jianjie'
import Chanpin from '@/components/main/chanpin'
import Shifang from '@/components/main/shifang'
import Yingshou from '@/components/main/yingshou'
import Address from '@/components/main/address'
import Contact from '@/components/main/contact'

import Renwu from '@/components/main/renwu'
import Renwu1 from '@/components/main/renwu1'
import Renwu2 from '@/components/main/renwu2'
import Renwu3 from '@/components/main/renwu3'
import Renwu4 from '@/components/main/renwu4'
import Renwu5 from '@/components/main/renwu5'
import Renwu6 from '@/components/main/renwu6'
import Renwu7 from '@/components/main/renwu7'
import Renwu8 from '@/components/main/renwu8'
import Renwu9 from '@/components/main/renwu9'
import Renwu10 from '@/components/main/renwu10'


import Company from '@/components/main/company'
import Company1 from '@/components/main/company1'
import Company2 from '@/components/main/company2'
import Company3 from '@/components/main/company3'
import Company4 from '@/components/main/company4'
import Company5 from '@/components/main/company5'
import Company6 from '@/components/main/company6'
import Company7 from '@/components/main/company7'
import Company8 from '@/components/main/company8'
import Company9 from '@/components/main/company9'
import Company10 from '@/components/main/company10'
import Company11 from '@/components/main/company11'
import Company12 from '@/components/main/company12'
import Company13 from '@/components/main/company13'
import Company14 from '@/components/main/company14'
import Company15 from '@/components/main/company15'
import Company16 from '@/components/main/company16'
import Company17 from '@/components/main/company17'
import Company18 from '@/components/main/company18'
import Company19 from '@/components/main/company19'
import Company20 from '@/components/main/company20'
import Company21 from '@/components/main/company21'
import Company22 from '@/components/main/company22'
import Company23 from '@/components/main/company23'
import Company24 from '@/components/main/company24'
import Company25 from '@/components/main/company25'


import Yanjiang1 from '@/components/main/yanjiang/1'
import Yanjiang2 from '@/components/main/yanjiang/2'
import Yanjiang3 from '@/components/main/yanjiang/3'
import Yanjiang4 from '@/components/main/yanjiang/4'

import Fo1 from '@/components/main/fo/1'
import Fo2 from '@/components/main/fo/2'
import Fo3 from '@/components/main/fo/3'

import Binlang1 from '@/components/main/binlang/1'
import Binlang2 from '@/components/main/binlang/2'
import Binlang3 from '@/components/main/binlang/3'
import Shipin from '@/components/main/shipin'

import Shop from '@/components/main/shop'
import Shop1 from '@/components/main/shop1'
import Shop2 from '@/components/main/shop2'
import Shopz from '@/components/main/shopz'
import Video from '@/components/main/video'
import Shopvideo from '@/components/main/shopvideo'
import Shopvideos from '@/components/main/shopvideos'
import Shopvideot from '@/components/main/shopvideot'

import Shouye1 from '@/components/main/shouye1'
import Shouyet from '@/components/main/shouyet'
import Yizhenkeji from '@/components/main/yizhenkeji/zhuchi'
import Niuzilongzhuchi from '@/components/main/niuzilong/zhuchi'
import Jianshenfang from '@/components/main/jianshen/zhuchi'
import Gaotiezhuchi from '@/components/main/gaotie/zhuchi'
import Szxxzhuchi from '@/components/main/shenzhenxiaoxue/zhuchi'
import Xiaoshiguan from '@/components/main/xiaoshiguan/zhuchi'
import Yuzhouzhimi from '@/components/main/yuzhouzhimi/zhuchi'

import Zhuchi from '@/components/main/zhuchi/zhuchi'
import Reseller from '@/components/main/reseller'
import Register from '@/components/main/register'
import Logins from '@/components/main/logins'
import Xiaoguo from '@/components/main/xiaoguo'
import Xiaoguox from '@/components/main/xiaoguox'
Vue.use(Router)

export default new Router({
  mode: 'history',
  bash: '/',
  routes: [

    {
      path: '/',
      component: Shouye1
    },
    {
      path: '/xiaoguo',
      name: 'Xiaoguo',
      component: Xiaoguo
    },
    {
      path: '/xiaoguox',
      name: 'Xiaoguox',
      component: Xiaoguox
    },
    {
      path: '/logins',
      name: 'logins',
      component: Logins
    },
    {
      path: '/zhuchi',
      name: 'zhuchi',
      component: Zhuchi
    },
    {
      path: '/jianshenfang',
      name: 'jianshenfang',
      component: Jianshenfang
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/reseller',
      name: 'reseller',
      component: Reseller
    },
    {
      path: '/yizhenkeji',
      name: 'yizhenkeji',
      component: Yizhenkeji
    },
    {
      path: '/niuzilongzhuchi',
      name: 'niuzilongzhuchi',
      component: Niuzilongzhuchi
    },
    {
      path: '/xiaoshiguan',
      name: 'xiaoshiguan',
      component: Xiaoshiguan
    },
    {
      path: '/yuzhouzhimi',
      name: 'yuzhouzhimi',
      component: Yuzhouzhimi
    },
    {
      path: '/szxxzhuchi',
      name: 'szxxzhuchi',
      component: Szxxzhuchi
    },
    {
      path: '/gaotiezhuchi',
      name: 'gaotiezhuchi',
      component: Gaotiezhuchi
    },
    {
      path: '/shouye1',
      name: 'shouye1',
      component: Shouye1
    },
    {
      path: '/shouyet',
      name: 'shouyet',
      component: Shouyet
    },
    {
      path: '/shopvideos',
      name: 'shopvideos',
      component: Shopvideos
    },
    {
      path: '/shopvideot',
      name: 'shopvideot',
      component: Shopvideot
    },
    {
      path: '/shopvideo',
      name: 'shopvideo',
      component: Shopvideo
    },
    {
      path: '/video',
      name: 'video',
      component: Video
    },
    {
      path: '/shop',
      name: 'shop',
      component: Shop
    },
    {
      path: '/shop1',
      name: 'shop1',
      component: Shop1
    },
    {
      path: '/shop2',
      name: 'shop2',
      component: Shop2
    },
    {
      path: '/shopz',
      name: 'shopz',
      component: Shopz
    },
    {
      path: '/shipin',
      name: 'shipin',
      component: Shipin
    },
    {
      path: '/binlang1',
      name: 'binlang1',
      component: Binlang1
    },
    {
      path: '/binlang2',
      name: 'binlang2',
      component: Binlang2
    },
    {
      path: '/binlang3',
      name: 'binlang3',
      component: Binlang3
    },
    {
      path: '/fo1',
      name: 'fo1',
      component: Fo1
    },
    {
      path: '/fo2',
      name: 'fo2',
      component: Fo2
    },
    {
      path: '/fo3',
      name: 'fo3',
      component: Fo3
    },
    {
      path: '/yanjiang1',
      name: 'yanjiang1',
      component: Yanjiang1
    },
    {
      path: '/yanjiang2',
      name: 'yanjiang2',
      component: Yanjiang2
    },
    {
      path: '/yanjiang3',
      name: 'yanjiang3',
      component: Yanjiang3
    },
    {
      path: '/yanjiang4',
      name: 'yanjiang4',
      component: Yanjiang4
    },
    {
      path: '/dianpu1',
      name: 'dianpu1',
      component: Dianpu1
    },
    {
      path: '/dianpu2',
      name: 'dianpu2',
      component: Dianpu2
    },
    {
      path: '/dianpu3',
      name: 'dianpu3',
      component: Dianpu3
    },
    {
      path: '/dianpu4',
      name: 'dianpu4',
      component: Dianpu4
    },
    {
      path: '/company',
      name: 'company',
      component: Company
    },
    {
      path: '/company1',
      name: 'company1',
      component: Company1
    },
    {
      path: '/company2',
      name: 'company2',
      component: Company2
    },
    {
      path: '/company3',
      name: 'company3',
      component: Company3
    },
    {
      path: '/company4',
      name: 'company4',
      component: Company4
    },
    {
      path: '/company5',
      name: 'company5',
      component: Company5
    },
    {
      path: '/company6',
      name: 'company6',
      component: Company6
    },
    {
      path: '/company7',
      name: 'company7',
      component: Company7
    },
    {
      path: '/company8',
      name: 'company8',
      component: Company8
    },
    {
      path: '/company9',
      name: 'company9',
      component: Company9
    },
    {
      path: '/company10',
      name: 'company10',
      component: Company10
    },
    {
      path: '/company11',
      name: 'company11',
      component: Company11
    },
    {
      path: '/company12',
      name: 'company12',
      component: Company12
    },
    {
      path: '/company13',
      name: 'company13',
      component: Company13
    },
    {
      path: '/company14',
      name: 'company14',
      component: Company14
    },
    {
      path: '/company15',
      name: 'company15',
      component: Company15
    },
    {
      path: '/company16',
      name: 'company16',
      component: Company16
    },
    {
      path: '/company17',
      name: 'company17',
      component: Company17
    },
    {
      path: '/company18',
      name: 'company18',
      component: Company18
    },
    {
      path: '/company19',
      name: 'company19',
      component: Company19
    },
    {
      path: '/company20',
      name: 'company20',
      component: Company20
    },
    {
      path: '/company21',
      name: 'company21',
      component: Company21
    },
    {
      path: '/company22',
      name: 'company22',
      component: Company22
    },
    {
      path: '/company23',
      name: 'company23',
      component: Company23
    },
    {
      path: '/company24',
      name: 'company24',
      component: Company24
    },
    {
      path: '/company25',
      name: 'company25',
      component: Company25
    },










    {
      path: '/renwu',
      name: 'renwu',
      component: Renwu
    },
    {
      path: '/renwu1',
      name: 'renwu1',
      component: Renwu1
    },
    {
      path: '/renwu2',
      name: 'renwu2',
      component: Renwu2
    },
    {
      path: '/renwu3',
      name: 'renwu3',
      component: Renwu3
    },
    {
      path: '/renwu4',
      name: 'renwu4',
      component: Renwu4
    },
    {
      path: '/renwu5',
      name: 'renwu5',
      component: Renwu5
    },
    {
      path: '/renwu6',
      name: 'renwu6',
      component: Renwu6
    },
    {
      path: '/renwu7',
      name: 'renwu7',
      component: Renwu7
    },
    {
      path: '/renwu8',
      name: 'renwu8',
      component: Renwu8
    },
    {
      path: '/renwu9',
      name: 'renwu9',
      component: Renwu9
    },
    {
      path: '/renwu10',
      name: 'renwu10',
      component: Renwu10
    },
    {
      path: '/jianjie',
      name: 'jianjie',
      component: Jianjie
    },
    {
      path: '/chanpin',
      name: 'chanpin',
      component: Chanpin
    },
    {
      path: '/shifang',
      name: 'shifang',
      component: Shifang
    },
    {
      path: '/yingshou',
      name: 'yingshou',
      component: Yingshou
    },
    {
      path: '/address',
      name: 'address',
      component: Address
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/changjing',
      name: 'changjing',
      component: Changjing
    },
    {
      path: '/changjing1',
      name: 'changjing1',
      component: Changjing1
    },
    {
      path: '/changjing2',
      name: 'changjing2',
      component: Changjing2
    },
    {
      path: '/changjing3',
      name: 'changjing3',
      component: Changjing3
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/list',
      name: 'list',
      component: List
    },
    {
      path: '/listm',
      name: 'listm',
      component: Listm
    },
    {
      path: '/baohu',
      name: 'baohu',
      component: Baohu
    },







    { path: '*', redirect: '/' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js